import {
  GET_MEMORY_STATUS_ROUTE,
  GET_MEMORY_CONFIG_ROUTE,
  GET_OBSERVATIONAL_MEMORY_ROUTE,
  AWAIT_BUFFER_STATUS_ROUTE,
  LIST_THREADS_ROUTE,
  GET_THREAD_BY_ID_ROUTE,
  LIST_MESSAGES_ROUTE,
  GET_WORKING_MEMORY_ROUTE,
  SAVE_MESSAGES_ROUTE,
  CREATE_THREAD_ROUTE,
  UPDATE_THREAD_ROUTE,
  DELETE_THREAD_ROUTE,
  CLONE_THREAD_ROUTE,
  UPDATE_WORKING_MEMORY_ROUTE,
  DELETE_MESSAGES_ROUTE,
  SEARCH_MEMORY_ROUTE,
  GET_MEMORY_STATUS_NETWORK_ROUTE,
  LIST_THREADS_NETWORK_ROUTE,
  GET_THREAD_BY_ID_NETWORK_ROUTE,
  LIST_MESSAGES_NETWORK_ROUTE,
  SAVE_MESSAGES_NETWORK_ROUTE,
  CREATE_THREAD_NETWORK_ROUTE,
  UPDATE_THREAD_NETWORK_ROUTE,
  DELETE_THREAD_NETWORK_ROUTE,
  DELETE_MESSAGES_NETWORK_ROUTE,
} from '../../handlers/memory';

export const MEMORY_ROUTES = [
  GET_MEMORY_STATUS_ROUTE,
  GET_MEMORY_CONFIG_ROUTE,
  GET_OBSERVATIONAL_MEMORY_ROUTE,
  AWAIT_BUFFER_STATUS_ROUTE,
  LIST_THREADS_ROUTE,
  GET_THREAD_BY_ID_ROUTE,
  LIST_MESSAGES_ROUTE,
  GET_WORKING_MEMORY_ROUTE,
  SAVE_MESSAGES_ROUTE,
  CREATE_THREAD_ROUTE,
  UPDATE_THREAD_ROUTE,
  DELETE_THREAD_ROUTE,
  CLONE_THREAD_ROUTE,
  UPDATE_WORKING_MEMORY_ROUTE,
  DELETE_MESSAGES_ROUTE,
  SEARCH_MEMORY_ROUTE,
  GET_MEMORY_STATUS_NETWORK_ROUTE,
  LIST_THREADS_NETWORK_ROUTE,
  GET_THREAD_BY_ID_NETWORK_ROUTE,
  LIST_MESSAGES_NETWORK_ROUTE,
  SAVE_MESSAGES_NETWORK_ROUTE,
  CREATE_THREAD_NETWORK_ROUTE,
  UPDATE_THREAD_NETWORK_ROUTE,
  DELETE_THREAD_NETWORK_ROUTE,
  DELETE_MESSAGES_NETWORK_ROUTE,
] as const;
